import React from 'react';
import './LoadingStateCard.scss';

/**
 * Shared loading state card used while fetching list data (cart, wishlist, etc.).
 * Renders the same card design with spinner and message.
 */
export function LoadingStateCard({ message = 'Loading...', wrapperClassName = '' }) {
  return (
    <div className={`mob-base-cartLayout-mob list-loading-state ${wrapperClassName}`.trim()}>
      <div className="empty-cart-container">
        <div className="list-loading-spinner" />
        <p className="empty-cart-message list-loading-message">{message}</p>
      </div>
    </div>
  );
}
